import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { UnitSelectiotButtomComponent, UnitSelectorComponent } from './unit-selection.component';
import { Ae2UnitSelectorServiceModule } from '@studios-smart/core/services/unit-selector';
import { Ae2ActivityServiceModule } from '@studios-smart/core/services/activities';
import { Ae2UnitSelectorModule } from '@studios-smart/core/components/unit-selector';
import { MatIconModule, MatButtonModule } from '@angular/material';
import { Ae2ArticleModule } from '@studios-smart/core/components/article';
import {Ga4EventDirectiveModule} from '@studios-smart/core/directives/ga4/ga4-event.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    Ae2UnitSelectorModule,
    FlexLayoutModule,
    Ae2UnitSelectorServiceModule,
    Ae2ActivityServiceModule,
    MatIconModule,
    MatButtonModule,
    Ae2ArticleModule,
    Ga4EventDirectiveModule
  ],
  declarations: [
    UnitSelectiotButtomComponent,
    UnitSelectorComponent
  ],
  exports: [UnitSelectiotButtomComponent],
  entryComponents: [UnitSelectorComponent]
})
export class UnitSelectionModule { }
